import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import MainPage from '../components/MainPage';
import getCompanies from '../actions/api/company/getCompanies';
import getOperators from '../actions/api/operators/getOperators';
import { SUCCESS_API_GET_ACCESS_CONTROL_OPERATORS } from '../actions/actionTypes';
import { ROLE } from '../lib/constants';
import config from '../config';

const INTERVAL_TIMER = 10000;

const updateContainer = (apiToken, searchOptions, dispatch) => {
  dispatch(getCompanies(apiToken, searchOptions));
};

const getSearchBoxHeight = () => {
  const obj = document.getElementById('CompanyPageSearchBox');
  return (obj && obj.clientHeight) || 0;
};

class CompanyContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchBoxHeight: 0,
    };
    const { apiToken, searchOptions, dispatch, showUserPrompt } = props;
    const params = { apiToken, searchOptions, dispatch, showUserPrompt };
    dispatch({ type: 'CLOSE_MENU' });
    dispatch({ type: 'RESET_OPERATOR_INFO' });
    dispatch({ type: 'OPEN_COMPANY' });
    // メール送信先ユーザーの選択肢を取得
    dispatch(
      getOperators(
        apiToken,
        {
          accountStatuses: config.searchAccountStatus.enable,
          roles: [ROLE.ADMIN, ROLE.COMPANY_ADMIN],
        },
        SUCCESS_API_GET_ACCESS_CONTROL_OPERATORS,
      ),
    );
    this.initialTimer(params);
  }

  componentDidMount() {
    const searchBoxHeight = getSearchBoxHeight();
    this.setState({ searchBoxHeight });
  }

  shouldComponentUpdate(props, state) {
    const resizedSearchBoxHeight = getSearchBoxHeight();
    const curSearchBoxHeight = state.searchBoxHeight;
    if (resizedSearchBoxHeight !== curSearchBoxHeight) {
      this.setState({ searchBoxHeight: resizedSearchBoxHeight });
    }
    const { apiToken, searchOptions, dispatch, showUserPrompt, refreshPage } =
      props;
    const params = {
      apiToken,
      searchOptions,
      dispatch,
      showUserPrompt,
      refreshPage,
    };
    this.initialTimer(params);
    return true;
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch({ type: 'RESET_COMPANY_SEARCH_OPTIONS' });
    this.closeTimer();
  }

  initialTimer(params) {
    const { dispatch, apiToken, searchOptions, showUserPrompt } = params;
    this.closeTimer();
    if (dispatch && apiToken && !showUserPrompt) {
      updateContainer(apiToken, searchOptions, dispatch);
      this.mainTimer = setInterval(
        () => updateContainer(apiToken, searchOptions, dispatch),
        INTERVAL_TIMER,
      );
    }
  }

  closeTimer() {
    if (this.mainTimer !== undefined) {
      clearInterval(this.mainTimer);
      delete this.mainTimer;
    }
  }

  render() {
    const { isLogin } = this.props;
    const { searchBoxHeight } = this.state;
    return (
      (!isLogin && <Redirect to="/login" />) || (
        <MainPage searchBoxHeight={searchBoxHeight} />
      )
    );
  }
}

CompanyContainer.propTypes = {
  isLogin: PropTypes.bool.isRequired,
  apiToken: PropTypes.string.isRequired,
  refreshPage: PropTypes.bool.isRequired,
  searchOptions: PropTypes.object.isRequired,
  showUserPrompt: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  isLogin: state.main.isLogin,
  role: state.main.userInfo.role,
  compatibleInfo: state.main.compatibleInfo,
  apiToken: state.main.apiToken,
  refreshPage: state.company.refreshPage,
  searchOptions: state.company.searchOptions,
  showUserPrompt: state.userPrompt.showUserPrompt,
});

export default connect(mapStateToProps)(CompanyContainer);
